import moment from 'moment';
import { DateFormatForDatePickerJP } from '../constants/date-picker-constant';
import { TimeFormatWithSeconds } from '../constants/time-picker-constant';
import dayjs, { Dayjs } from 'dayjs';
import { emptyValue } from '../constants/constants';

export const getFormattedTime = (time: string) => {
  return moment(time, TimeFormatWithSeconds).format(TimeFormatWithSeconds);
};

export const getFormattedDateForBackend = (date: Date) => {
  return moment(date).format(DateFormatForDatePickerJP);
};

/**
* Formats a raw ISO date/date-time string for grid display
* @param cell: Raw ISO date string
*/
export const formatGridDate = (cell: string | null | undefined): string => {
  if (!cell) return emptyValue;
  const date = new Date(cell);
  if (isNaN(date.getTime())) return cell;
  const pad = (n: number) => String(n).padStart(2, '0');
  return `${date.getFullYear()}/${pad(date.getMonth() + 1)}/${pad(date.getDate())}`;
};

/**
* Formats a raw ISO date/date-time string for grid display, keeping the time component.
* "yyyy-MM-dd HH:mm".
* @param cell: Raw ISO date-time string
*/
export const formatGridDateTime = (cell: string | null | undefined): string => {
  if (!cell) return emptyValue;
  const date = new Date(cell);
  if (isNaN(date.getTime())) return cell;
  const pad = (n: number) => String(n).padStart(2, '0');
  return `${date.getFullYear()}/${pad(date.getMonth() + 1)}/${pad(date.getDate())} ${pad(
    date.getHours()
  )}:${pad(date.getMinutes())}`;
};

/**
* Formats a raw ISO date/date-time string for grid display, keeping seconds.
* "yyyy/MM/dd HH:mm:ss".
* @param cell: Raw ISO date-time string
*/
export const formatGridDateTimeWithSeconds = (cell: string | null | undefined): string => {
  if (!cell) return emptyValue;
  const date = new Date(cell);
  if (isNaN(date.getTime())) return cell;
  const pad = (n: number) => String(n).padStart(2, '0');
  return `${date.getFullYear()}/${pad(date.getMonth() + 1)}/${pad(date.getDate())} ${pad(
    date.getHours()
  )}:${pad(date.getMinutes())}:${pad(date.getSeconds())}`;
};

export const HHMMToMinutes = (value: string | Dayjs): number => {
    if (!value) return 0;

    // If it's a Dayjs object
    if (dayjs.isDayjs(value)) {
      const hours = value.hour();
      const minutes = value.minute();
      return hours * 60 + minutes;
    }

    // If it's a string in HH:mm format
    if (typeof value === 'string' && value.includes(':')) {
      const [h, m] = value.split(':').map(Number);
      return h * 60 + m;
    }

    return 0;
  };

export const secondsToHHMMSS = (totalSeconds: number): string => {
  if (!totalSeconds || isNaN(totalSeconds)) return '00:00:00';

  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = Math.floor(totalSeconds % 60);

  const hh = String(hours).padStart(2, '0');
  const mm = String(minutes).padStart(2, '0');
  const ss = String(seconds).padStart(2, '0');

  return `${hh}:${mm}:${ss}`;
};
